export const programConstante = Object.freeze({
  PROGRAM_STATUS_DISABLE: 1,
  PROGRAM_STATUS_ENABLE: 2,
  PROGRAM_STATUS_SUCCESS: 3,
});
